<template>
  <svg width="24" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15.1963" cy="3.67865" r="2.84" :stroke="color" stroke-width="1.56"/>
    <circle cx="3.67865" cy="18.3214" r="2.84" :stroke="color" stroke-width="1.56"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M11.464 0.0886956C11.0267 0.543195 10.6717 1.07737 10.4228 1.6673C9.34278 1.80184 8.42841 2.24347 7.67969 2.99219C6.80104 3.87083 6.34531 4.9776 6.3125 6.3125C6.34531 7.6474 6.80104 8.75417 7.67969 9.63281C8.55833 10.5115 9.6651 10.9672 11 11C12.3349 10.9672 13.4417 10.5115 14.3203 9.63281C14.5633 9.38987 14.7739 9.12948 14.9521 8.85165C15.0331 8.85541 15.1145 8.85731 15.1963 8.85731C15.7615 8.85731 16.3055 8.76678 16.8146 8.59945C16.509 9.39567 16.0437 10.1063 15.4188 10.7312C14.2469 11.9031 12.774 12.5135 11 12.5625C9.22604 12.5135 7.75312 11.9031 6.58125 10.7312C5.40938 9.55937 4.79896 8.08646 4.75 6.3125C4.79896 4.53854 5.40938 3.06563 6.58125 1.89375C7.75312 0.721875 9.22604 0.111458 11 0.0625C11.157 0.0668333 11.3117 0.0755658 11.464 0.0886956ZM18.8125 20.375V18.0312C18.7964 17.3641 18.5685 16.8107 18.1289 16.3711C17.6893 15.9315 17.1359 15.7036 16.4688 15.6875H8.13844C7.7753 15.0739 7.28915 14.5418 6.71394 14.125H16.4688C17.5755 14.1578 18.4951 14.5404 19.2273 15.2727C19.9596 16.0049 20.3422 16.9245 20.375 18.0312V20.375C20.375 20.6031 20.3018 20.7904 20.1555 20.9367C20.0091 21.0831 19.8219 21.1562 19.5938 21.1562C19.3656 21.1562 19.1784 21.0831 19.032 20.9367C18.8857 20.7904 18.8125 20.6031 18.8125 20.375Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'HeatMap',
  props: {
    color: {
      type: String,
      default: '#909399'
    }
  },
  computed: {},
};
</script>
